import { render, staticRenderFns } from "./CreateDisinfectedPallet.vue?vue&type=template&id=36a884d0"
import script from "./CreateDisinfectedPallet.vue?vue&type=script&lang=js"
export * from "./CreateDisinfectedPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports